module.exports = __webpack_public_path__ + "img/cn-stu-j-t.6c8dbc19.png";